import { render } from "./exchange_huobi.vue?vue&type=template&id=87f56dde&scoped=true"
import script from "./exchange_huobi.vue?vue&type=script&lang=js"
export * from "./exchange_huobi.vue?vue&type=script&lang=js"

import "./exchange_huobi.vue?vue&type=style&index=0&id=87f56dde&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f56dde"]])

export default __exports__